// export const AUTH = 'http://10.10.34.13:8080/course/auth/v2'
export const AUTH = window.location.origin + '/course/auth/v2';

export const COURSE = window.location.origin + '/course/app';

export const COURSE_V2 = window.location.origin + '/course_v2/course';

export const HOMEWORK = window.location.origin + `/onlinepages/course_h5/?v=${Math.floor(Math.random() * 1000)}&from=pc`;

export const COURSE_API = {
    // 2.0新接口
    report_record: '/course_v2/situation/report_record',
    encourage_record: '/course_v2/situation/encourage_record',
    encourage_pre_record: '/course_v2/situation/encourage_init',
    encourage_report: '/course_v2/situation/encourage_report',

    // 课程相关
    lesson_home: '/course/app/v4/lesson/home',
    user: '/course/app/v3/user',
    course_list: '/course/app/course_list',
    unit: '/course/app/v5/unit',
    lesson: '/course/app/v2/lesson',
    trial_lesson: '/course/app/trial/lesson',
    close: '/course/app/v2/lesson/home/close',
    level_lessons: '/course/app/level/v2/lessons',
    level_contents: '/course/app/level/contents',
    feedback: '/course/app/lesson/feedback',
    default_level: '/course/order/app/defaultLevel',
    open_course: '/course/order/app/openCourse',
    get_reportUrl: '/course/app/report_url',
    video_list: '/course/app/v2/lesson/video/list',

    // baby-info 相关
    kid_names: '/course/app/kid_names',
    exam_records: '/course/app/levelExam/examRecords',
    upload_image: '/course/app/upload_image',
    add_user: '/course/app/add_user',

    // bind-weixin 相关
    bind_wx: '/course/app/bind_wx',
    unbind_wx: '/course/app/unbind_wx',

    // 课时兑换相关
    activity_usecode: '/course/app/activity/useCode',

    // FM 相关
    song_home: '/course/app/song/home',
    new_song_list: '/course/app/childrensong/list',
    song_list: '/course/app/childrensong/collections',  //'/course/app/song/list',
    song_collect: '/course/app/childrensong/collect',

    // 礼物相关
    gift_list: '/course/app/v2/gift/list',
    save_gift: '/course/app/v2/saveGift/',

    // setting 相关
    pause_button: '/course/app/pause_button',
};



// WEBPACK FOOTER //
// ./src/utils/Req.js